import React, { Component, Fragment } from 'react';
import moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as ReportsActions } from 'store/ducks/reports';

import { Page, Breadcrumbs, Panel, Loading } from 'components';
import { Filters } from './components';

class Create extends Component {
  state = {
    filter: {
      start_at: null,
      end_at: null,
      date_formatted: '',
    },
    blob: '',
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Relatórios', to: '/reports' },
      { name: 'Relatório de Provisão de Pontos', to: '' },
    ],
  };

  componentDidMount() {
    const { getReportPointsProvisionRequest } = this.props;

    getReportPointsProvisionRequest(this.state.filter);
  }

  componentDidUpdate(oldProps, oldState) {
    const { filter } = this.state;

    if (oldState.filter.start_at !== filter.start_at || oldState.filter.end_at !== filter.end_at) {
      const date_formatted = filter.start_at
        ? `${filter.start_at !== null ? moment(filter.start_at).format('DD/MM/YYYY') : ''} ${
            filter.end_at !== null ? '-' : ''
          } ${filter.end_at !== null ? moment(filter.end_at).format('DD/MM/YYYY') : ''}`
        : '';

      this.setState({ filter: { ...filter, date_formatted } });
    }
  }

  handleChangeDate = async (name, value) => {
    const { filter } = this.state;
    const { getReportPointsProvisionRequest } = this.props;

    await this.setState({ filter: { ...filter, [name]: value } });
    getReportPointsProvisionRequest(this.state.filter);
  };

  handleCleanFilter = async e => {
    e.preventDefault();

    const { getReportPointsProvisionRequest } = this.props;

    await this.setState({
      filter: {
        start_at: null,
        end_at: null,
        date_formatted: '',
      },
    });

    getReportPointsProvisionRequest(this.state.filter);
  };

  handleExport = async (name, value) => {
    const { filter } = this.state;
    const { exportReportProvisionPointsRequest } = this.props;

    await this.setState({ filter: { ...filter, [name]: value } });
    exportReportProvisionPointsRequest(this.state.filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { reports } = this.props;

    return (
      <Page className="page-reports">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <header className="page-reports-header">
          <Page.Title>Relatório de Provisionamento de Pontos</Page.Title>
        </header>

        <Panel className="panel-list">
          {!reports.data.length && reports.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {reports.loading && <Loading type="table" size="x-large" />}

              {filter.date_formatted !== '' && (
                <Panel.Title>
                  Período: <span>{filter.date_formatted}</span>
                </Panel.Title>
              )}

              <h5>Relatório de Provisão de Pontos</h5>

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th className="subTitle-report">Loja</th>
                    <th className="subTitle-report">Saldo de Pontos</th>
                    <th className="subTitle-report">Provisão(R$)</th>
                  </tr>
                </thead>

                <tbody>
                  {!reports.data.length && (
                    <tr>
                      <td colSpan="3" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}
                  {reports.data.map(report => (
                    <tr key={report.id}>
                      <td>{report.attributes.name}</td>
                      <td>{parseFloat(report.attributes.total).toLocaleString('pt-BR')}</td>
                      <td>
                        {parseFloat(report.attributes.provision).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr className="total">
                    <th>Total</th>
                    <th>{reports.total.points.toLocaleString('pt-BR')}</th>
                    <th>{reports.total.provision.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</th>
                  </tr>
                </tfoot>
              </table>

              <Filters data={filter} onChange={this.handleChangeDate} onClean={this.handleCleanFilter} />

              <button className="button-submit" onClick={this.handleExport}>
                Exportar Planilha
              </button>
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapstate = state => ({
  reports: state.reports.pointsProvision,
});

const mapActions = dispatch => bindActionCreators(ReportsActions, dispatch);

export default connect(
  mapstate,
  mapActions,
)(Create);
